import type { AppRemoteConfig, PlatformRemoteConfig } from '@hexa/app/platform/Platform';
import { FacebookRemoteConfig } from '@hexa/app/platform/facebook/firebase/FacebookRemoteConfig';

export class WebRemoteConfig implements PlatformRemoteConfig {
  private readonly cachedRemoteConfig: FacebookRemoteConfig = new FacebookRemoteConfig();

  public async init(): Promise<void> {
    await this.cachedRemoteConfig.init();
  }

  public getRemoteConfig(): AppRemoteConfig {
    const baseConfig = this.cachedRemoteConfig.getRemoteConfig();
    return {
      ...baseConfig,
      // Override for azerion-specific remote config values
      ads: {
        ...baseConfig.ads,
        interstitials: {
          ...baseConfig.ads.interstitials,
          cooldownSeconds: 0, // Disable cooldown between interstitials
          maxAdsPerSession: 0, // Disable max ads per session
          firstLevel: 1, // Show interstitials from the first level
        },
      },
    };
  }
}
